export default {
  title: '成员',
  name: 'member',
  path: '/member/index',
  show: true,
  icon: 'icon-zuocedaohang-shouye1',
  perm: '',
  zIndex: 2,
  children: {
    member: {
        title: '成员列表',
        name: 'member',
        path: '/member/index',
        icon: "icon-zuocedaohang-shouye1",
        perm:'',
        show: ($route) =>
                $route?.path === "/member/index"
    },
    jt: {
      title: '归属小组',
      name: 'member',
      path: '/member/jt',
      icon: "icon-zuocedaohang-shouye1",
      perm:'',
      show: ($route) =>
              $route?.path === "/member/jt"
    },
    mcate: {
      title: '班级职位',
      name: 'member',
      path: '/member/cate',
      icon: "icon-zuocedaohang-shouye1",
      perm:'',
      show: ($route) =>
              $route?.path === "/member/cate"
    },
    bw: {
      title: '所在班级',
      name: 'member',
      path: '/member/bw',
      icon: "icon-zuocedaohang-shouye1",
      perm:'',
      show: ($route) =>
              $route?.path === "/member/bw"
    },
    industry: {
        title: '公司行业',
        name: 'member',
        path: '/member/industry',
        icon: "icon-zuocedaohang-shouye1",
        perm:'',
        show: ($route) =>
                $route?.path === "/member/industry"
    }
  }
}
